import React from 'react';
import './style.css';

function Contact() {
  return (
    <section id="contact" className="contact-section">
      <div className="content-section">
        <div className="section-heading"><div><span className="eyebrow">Get in touch</span><h2>Contact</h2></div></div>
        <div className="contact-grid">
          <div className="casual-section">
            <h3>Say Hi!</h3>
            <p>Have a note for Paige? Send it here.</p>
            <form method="POST" action="https://formspree.io/paigefaure@gmail.com">
              <label htmlFor="contact-name">Name *</label>
              <input id="contact-name" required type="text" name="name" autoComplete="name" />
              <label htmlFor="contact-email">Email Address *</label>
              <input id="contact-email" required type="email" name="_replyto" autoComplete="email" />
              <label htmlFor="contact-message">Message *</label>
              <textarea id="contact-message" required name="message" rows="5" />
              <button className="button button-dark" type="submit">Submit <span aria-hidden="true">↗</span></button>
            </form>
          </div>
          <div className="professional-section">
            <span className="eyebrow">Representation</span>
            <h3>For Professional<br />Inquiries</h3>
            <div>Contact</div>
            <div>Daniel Hoff Agency</div>
            <div>attn: Dustin Flores</div>
            <img src="/daniel_hoff_logo.jpeg" alt="Daniel Hoff Agency" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
